import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useUpdateSmsPreferenceStatus } from "../../../logic";
import { useOptimisticUpdatePortalOrder } from "../../../logic/optimisticUpdates";

export function SmsRevokeConsentDialog({ open, back }: {
  open: boolean;
  back: () => void;
}) {

  const { closingId } = useParams()
  const { search } = useLocation()

  const { optimisticUpdatePortalOrder } = useOptimisticUpdatePortalOrder()

  const { mutate } = useUpdateSmsPreferenceStatus(search, { 
    useErrorBoundary: true ,
    onMutate: () => {
      optimisticUpdatePortalOrder({
        orderKey: closingId ?? '',
        search,
        patch: {
          SmsPreferenceStatus: {
            consent: false,
            phoneNumber: null
          }
        }
      })
      back()
    },
  })

  return <Dialog open={open}>
    <DialogContent>
      <DialogContentText sx={{ mb: 1 }} variant='h6'>
        Revoke Consent
      </DialogContentText>
      <DialogContentText>
        Are you sure? By revoking consent, you will no longer receive updates about your transactions via text message.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ p: 2 }}>
      <Button type="button" variant="outlined" onClick={() => back()} sx={{ width: { xs: '100%', sm: 'auto' } }}>No</Button>
      <Button
        type="button"
        variant="contained"
        color="error"
        onClick={() => { mutate({ consent: false, orderKey: closingId! }) }}
        sx={{ width: { xs: '100%', sm: 'auto' } }}
      >
        Yes, Revoke Consent
      </Button>
    </DialogActions>
  </Dialog >
}
